import { createStore, applyMiddleware, compose } from "redux";
import reducers from "./reducers";
import { createLogger } from "redux-logger";
import createSagaMiddleware from 'redux-saga'
import rootSaga from "../sagas";
import { routerMiddleware } from "connected-react-router";
import history from "../lib/history";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore, persistReducer, createTransform } from 'redux-persist'
import storage from 'redux-persist/lib/storage';
import { init as initialTransState } from "./reducers/trans/transReducer";

//blacklist nested state -
//https://github.com/rt2zz/redux-persist/issues/1110
//https://stackoverflow.com/questions/58483934/how-to-make-redux-persist-blacklist-for-nested-state/63845127#63845127
const getBlacklistForQuickbuy = createTransform(
  null,
  (state, key) => {
    let newState = { ...state }
    newState.totalAmountData = null;
    return newState;
  },
  { whitelist: ['Quickbuy'] }
);

const getBlacklistForQuickcategory = createTransform(
  null,
  (state, key) => {
    let newState = { ...state }    
    newState.cartBoxData = [];
    return newState;
  },
  { whitelist: ['Quickcategory'] }
);

const getBlacklistForTrans = createTransform(
  null,
  (state, key) => {
    let newState = { ...state }
    const {singleCartData, ...rest} = initialTransState
    console.log("checking at line 41: ", newState, singleCartData, initialTransState, rest);
    newState = {...newState, ...rest}
    console.log("checking at line 43: ", newState);
    return newState;
  },
  { whitelist: ['trans'] }
);

const persistConfig = {
  key: 'root',
  storage,
  // blacklist: [''],
  whitelist: ['Auth', 'Quickcategory', 'Quickbuy', 'QuickbuyApi', 'fabPlan', 'trans'],
  transforms: [getBlacklistForQuickbuy, getBlacklistForQuickcategory, getBlacklistForTrans],
}


const sagaMiddleware = createSagaMiddleware()

// add logger in middleware if wanted to be logged
const logger = createLogger({
  predicate: (getState, action) => !!process.env.NODE_ENV
});
// if (action === 'removeCartData') {
//   console.log("in  storage.removeItem");
//   storage.removeItem('persist:root')
// }
const connectedRouterMiddleware = routerMiddleware(history);
const persistedReducer = persistReducer(persistConfig, reducers)
const initialstore = {};
let middlewares = [
  sagaMiddleware,
];
if (!process.env.IS_SERVER) {
  middlewares.push(connectedRouterMiddleware);
}
const enhancers = [composeWithDevTools(applyMiddleware(...middlewares))];
const store = createStore(persistedReducer,
  initialstore,
  compose(
    ...enhancers
  ));
sagaMiddleware.run(rootSaga);
store.asyncReducers = {};
const persistor = persistStore(store);

export { store, persistor };


// export default function configureStore(initialState = {}) {
//   // Create the store with two middlewares
//   let middlewares = [
//     logger,
//     sagaMiddleware,
//   ];

//   if (!process.env.IS_SERVER) {
//     middlewares.push(connectedRouterMiddleware);
//   }

//   const enhancers = [composeWithDevTools(applyMiddleware(...middlewares))];
//   //const enhancers = [(applyMiddleware(...middlewares))];

//   if (!process.env.IS_SERVER && process.env.REACT_APP_MODE === "development") {
//     if (window && window.__REDUX_DEVTOOLS_EXTENSION__) {
//       enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__())
//     }
//   }

//   const store = createStore(
//     reducers,
//     initialState,
//     compose(
//       ...enhancers
//     )
//   );

//   sagaMiddleware.run(rootSaga);
//   // Extensions
//   //store.runSaga = sagaMiddleware.run
//   store.asyncReducers = {}; // Async reducer registry

//   return store;
// }
